import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../config/firebase";
import { getLocalUser, subscribeLocalAuth } from "../config/localAuth";

/**
 * Returns current auth state from Firebase and/or local-dev session.
 */
export function useAuth() {
  const [user, setUser] = useState(null);
  const [localUser, setLocalUser] = useState(() => getLocalUser());

  useEffect(() => {
    const syncLocal = () => setLocalUser(getLocalUser());
    syncLocal();
    return subscribeLocalAuth(syncLocal);
  }, []);

  useEffect(() => {
    if (!auth) return;

    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser ?? null);
    });

    return () => unsubscribe();
  }, []);

  const activeUser = user || localUser;
  const userEmail = activeUser?.email ?? "";
  const userName = String(activeUser?.displayName || "").trim();

  return {
    user: activeUser,
    userEmail,
    userName,
    isLoggedIn: Boolean(activeUser),
    isLocalUser: Boolean(localUser) && !user,
    auth,
  };
}
